/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlayEventRequest
 */
export interface PlayEventRequest {
    /**
     * 
     * @type {string}
     * @memberof PlayEventRequest
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof PlayEventRequest
     */
    timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof PlayEventRequest
     */
    uuid: string;
    /**
     * 
     * @type {string}
     * @memberof PlayEventRequest
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayEventRequest
     */
    employeeId?: string;
    /**
     * 
     * @type {any}
     * @memberof PlayEventRequest
     */
    data: any | null;
}

/**
 * Check if a given object implements the PlayEventRequest interface.
 */
export function instanceOfPlayEventRequest(value: object): value is PlayEventRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    if (!('uuid' in value) || value['uuid'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function PlayEventRequestFromJSON(json: any): PlayEventRequest {
    return PlayEventRequestFromJSONTyped(json, false);
}

export function PlayEventRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayEventRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'timestamp': json['timestamp'],
        'uuid': json['uuid'],
        'deviceId': json['deviceId'] == null ? undefined : json['deviceId'],
        'employeeId': json['employeeId'] == null ? undefined : json['employeeId'],
        'data': json['data'],
    };
}

export function PlayEventRequestToJSON(json: any): PlayEventRequest {
    return PlayEventRequestToJSONTyped(json, false);
}

export function PlayEventRequestToJSONTyped(value?: PlayEventRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'timestamp': value['timestamp'],
        'uuid': value['uuid'],
        'deviceId': value['deviceId'],
        'employeeId': value['employeeId'],
        'data': value['data'],
    };
}

